import React from 'react'

export const IconHeart = (props) => {
  return (
    <svg viewBox="0 0 30 30" fill="none" stroke='currentColor' xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M15 25.3125C15 25.3125 3.28125 18.75 3.28125 10.7813C3.28125 9.37253 3.76933 8.00732 4.66245 6.91789C5.55556 5.82846 6.79855 5.08212 8.17992 4.80585C9.56129 4.52957 10.9957 4.74043 12.2391 5.40255C13.4826 6.06467 14.4582 7.13715 15 8.43751V8.43751C15.5418 7.13715 16.5174 6.06467 17.7609 5.40255C19.0043 4.74043 20.4387 4.52957 21.8201 4.80585C23.2015 5.08212 24.4444 5.82846 25.3376 6.91789C26.2307 8.00732 26.7188 9.37253 26.7188 10.7813C26.7188 18.75 15 25.3125 15 25.3125Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
